/*
 *             Copyright (c) 2016 - 2021, CKSource - Frederico Knabben. All rights reserved.
 *
 *
 *
 *
 *          +---------------------------------------------------------------------------------+
 *          |                                                                                 |
 *          |                                 Hello stranger!                                 |
 *          |                                                                                 |
 *          |                                                                                 |
 *          |   What you're currently looking at is the source code of a legally protected,   |
 *          |    proprietary software. Any attempts to deobfuscate / disassemble this code    |
 *          |               are forbidden and will result in legal consequences.              |
 *          |                                                                                 |
 *          |                                                                                 |
 *          +---------------------------------------------------------------------------------+
 *
 *
 *
 *
 */
const _0x3410=['fields','description','root'];(function(_0x2fb9ce,_0x341032){const _0x62cef2=function(_0x15fd8b){while(--_0x15fd8b){_0x2fb9ce['push'](_0x2fb9ce['shift']());}};_0x62cef2(++_0x341032);}(_0x3410,0x12c));const _0x62ce=function(_0x2fb9ce,_0x341032){_0x2fb9ce=_0x2fb9ce-0x0;let _0x62cef2=_0x3410[_0x2fb9ce];return _0x62cef2;};import _0x44a8e6 from'./attributeoperationcompressor';export default class c extends _0x44a8e6{static get['description'](){const _0x46f23e=_0x44a8e6[_0x62ce('0x1')];return delete _0x46f23e[_0x62ce('0x0')]['range'],_0x46f23e[_0x62ce('0x0')][_0x62ce('0x2')]={'type':'string','id':0x1},_0x46f23e;}}